import { useState, useMemo, useEffect } from "react";
import SearchableDD from "./searchableDropdown/SearchableDD";
import ImagesDD from "./imagesDropdown/ImagesDD";
import RadioDD from "./radioDropdown/RadioDD";

function SelectButton({ icon, chevron, title, panelType, data, radioName, desktop, updateFilterValue, selectedInps }) {
  const [active, setActive] = useState(false);
  const [activeFilter, setActiveFilter] = useState(false);

  useEffect(() => {
    setActiveFilter(selectedInps)
  }, [selectedInps])

  const panel = useMemo(() => panelType === "searchDD" ? <SearchableDD active={active} entries={data} updateFilterValue={updateFilterValue} selectedInps={selectedInps} placeholder={"Nach Farbe suchen..."} filterName="fabric" />
    : panelType === "imagesDD" ? <ImagesDD active={active} setActive={setActive} entries={data} updateFilterValue={updateFilterValue} selectedInps={selectedInps} />
      : panelType === "radioDD" ? <RadioDD active={active} setActive={setActive} entries={data} DDname={radioName} updateFilterValue={updateFilterValue} />
        : null
    , [panelType, active, data, updateFilterValue, selectedInps, radioName])
  return (
    <div className={"filter " + desktop + "-desktop " + (activeFilter && activeFilter.length !== 0 ? "active" : "")} onClick={() => active ? null : setActive(true)}>
      <img src={icon} alt="" />
      {title}
      <img className="chevron" src={chevron} alt="" />
      <div className={"dd-close-overlay " + (active ? "active" : "")} onClick={() => setActive(false)}></div>
      {panel}
    </div>
  );
}

export default SelectButton